export const HELP_FACTS = {
  signupCredits: 5,
  dailyCheckInCredits: 1,
  checkInStreakDays: 7,
  checkInStreakExtraCredits: 1,
  cloudDefaultAbstracts: 30,
  cloudAbstractMaxKb: 10,
  managedGenerationCredits: 2,
  blindReviewCredits: 1,
} as const;
